import LogView from '@/views/app/LogView.vue'
import RequestView from '@/views/app/RequestView.vue'

export default [
	{ 
		path: '/app/logs', 
		name: 'log-view', 
		component: LogView, 
		meta: { 
			back: (route) => ({ name: 'list-vehicles' }), 
		}, 
	},
	{
		path: '/app/requests',
		name: 'request-view',
		component: RequestView,
		meta: { 
			back: (route) => ({ name: 'list-vehicles' }), 
		}, 
	}
]